__turbopack_context__.v({
  "cardBody": "PolicyAccordion-module__90N9OG__cardBody",
  "cardHeader": "PolicyAccordion-module__90N9OG__cardHeader",
  "cardSection": "PolicyAccordion-module__90N9OG__cardSection",
  "cardSectionFirst": "PolicyAccordion-module__90N9OG__cardSectionFirst",
  "cardTitle": "PolicyAccordion-module__90N9OG__cardTitle",
  "chevronOpen": "PolicyAccordion-module__90N9OG__chevronOpen",
  "overviewLabel": "PolicyAccordion-module__90N9OG__overviewLabel",
  "policyHtml": "PolicyAccordion-module__90N9OG__policyHtml",
  "policyList": "PolicyAccordion-module__90N9OG__policyList",
  "wrap": "PolicyAccordion-module__90N9OG__wrap",
});
